import { SecureAction } from '../../secure-actions';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class AnalyticsAdditionalSourcesSecureAction extends SecureAction {
  public static readonly VIEW: SecureAction = new AnalyticsAdditionalSourcesSecureAction('device:analytics:additional_sources|view');

  private constructor(name: string) {
    super(name);
  }
}
